import * as React from 'react';
import { FC } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CarouselStyled, { Indicator, ArrowButton } from './CarouselStyled';
import ChevronLeft from '../Icons/fill/ChevronLeft';
import ChevronRight from '../Icons/fill/ChevronRight';
import { variants, transitionSettings } from '~/constants/carousel';
import { handleOnDragEnd } from '~/helpers/carousel';

interface Props {
  productIndex: number;
  direction: number;
  paginate: (index: number) => void;
  productsLength: number;
}

const Carousel: FC<Props> = ({ productIndex, direction, paginate, productsLength, children }) => {
  return (
    <CarouselStyled>
      <AnimatePresence initial={false} custom={direction}>
        <div className="carousel__frame">
          <motion.div
            className="carousel__slide"
            key={productIndex}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={transitionSettings}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={1}
            onDragEnd={(_, { offset, velocity }) =>
              handleOnDragEnd({ productIndex, paginate, productsLength, offset, velocity })
            }
          >
            {children}
          </motion.div>
        </div>
      </AnimatePresence>
      <div className="carousel__controls">
        <ArrowButton
          aria-labelledby="previous"
          data-testid="carousel-prev"
          className={`prev ${productIndex === 0 && 'hide'}`}
          onClick={() => paginate(-1)}
        >
          <ChevronLeft aria-label="previous" />
        </ArrowButton>
        {Array(productsLength)
          .fill(null)
          .map((_, index) => (
            <Indicator key={index} selected={productIndex === index} />
          ))}
        <ArrowButton
          aria-labelledby="next"
          data-testid="carousel-next"
          className={`next ${productsLength - 1 === productIndex && 'hide'}`}
          onClick={() => paginate(1)}
        >
          <ChevronRight aria-label="next" />
        </ArrowButton>
      </div>
    </CarouselStyled>
  );
};

Carousel.displayName = 'Carousel';

export default Carousel;
